import { derived, writable } from 'svelte/store';
import config from './config';

/** @type {import('svelte/store').Writable<Object<string, any>>} */
const filters = writable(config.initialValue);

export const activeFilterCount = derived(filters, ($filters) => {
	let activeCount = 0;

	Object.keys($filters).forEach((key) => {
		if (key === 'offer_type' || key === 'city') {
			return;
		}
		if (key === 'location_type' || key === 'lat' || key === 'lon' || key === 'radius') {
			return;
		}
		if (key === 'offers_since' && $filters[key] === 'all-time') {
			return;
		}
		if (key === 'sort_by' && $filters[key] === 'accuracy') {
			return;
		}

		const filter = $filters[key];

		if (filter === null || filter === undefined) {
			return;
		}

		if (Array.isArray(filter)) {
			if (filter.length > 0) {
				activeCount++;
			}
		} else if (typeof filter === 'object' && filter !== null) {
			if (
				(filter.min !== null && filter.min !== undefined) ||
				(filter.max !== null && filter.max !== undefined)
			) {
				activeCount++;
			}
		} else {
			if (filter !== null) {
				activeCount++;
			}
		}
	});

	return activeCount;
});

export default filters;
